import React, {Fragment} from 'react';
import Select from 'react-select';
import {StringUtility} from "../common/StringUtility";
import {InvoiceDataUtility} from "../common/InvoiceDataUtility";
import {SelectUtility} from "../common/SelectUtility";
import {Constants} from "../common/Constants";

const getInvoiceLineFieldId = InvoiceDataUtility.getInvoiceLineFieldId

export let InvoiceLineWithServicesFormRow = (props) => {
    let selectedInvoiceLineTypeOption = SelectUtility.selectOptionForId(
        props.invoiceLine.invoice_line_type_id,
        props.qboInvoiceLineTypeOptions
    )
    let selectedFpServiceOption = SelectUtility.selectOptionForId(
        props.invoiceLine.fp_service_id,
        props.fpServiceOptions
    )

    let lineTypeColumn;
    let fpServiceContent;
    let nameContent;
    let fpServiceTypeContent;
    let amountContent;
    let deleteColumn;

    if (props.allowEdits) {
        lineTypeColumn = (
            <div
                className={props.getFormFieldClasses(
                    "common-form-list-row-cell type",
                    getInvoiceLineFieldId(props.invoiceLinesFieldId, "invoice_line_type_id", props.index)
                )}
            >
                <Select
                    className="common-form-select invoice-line-type-select"
                    classNamePrefix="common-form-select"
                    value={SelectUtility.selectOptionForId(
                        props.invoiceLine.invoice_line_type_id,
                        props.qboInvoiceLineTypeOptions
                    )}
                    onChange={(option) => props.handleInvoiceLineSelectChange(
                        'invoice_line_type_id',
                        option
                    )}
                    options={props.qboInvoiceLineTypeOptions}
                />
            </div>
        )
        nameContent = (
            <input
                type="text"
                className="common-form-input"
                value={props.invoiceLine.name}
                onChange={(event) => props.handleInvoiceLineTextFieldChange(
                    "name",
                    event
                )}
            />
        )
        amountContent = (
            <Fragment>
                <div className="amount-dollar-sign">
                    $
                </div>
                <input
                    type="text"
                    className="common-form-input"
                    value={props.invoiceLine.amount}
                    onChange={(event) => props.handleInvoiceLineTextFieldChange(
                        "amount", event
                    )}
                    onBlur={() => props.forceInvoiceLineValueToFloat('amount')}
                />
            </Fragment>
        )
        deleteColumn = (
            <div
                className="common-form-list-row-cell delete-button invoice-line-delete-button"
                title="Delete"
                onClick={props.deleteInvoiceLineItem}
            >
                <img
                    src="/static/images/close-textcolor.svg"
                    className="invoice-line-delete-button-icon"
                />
            </div>
        )

        if (
            selectedInvoiceLineTypeOption &&
            selectedInvoiceLineTypeOption.value === Constants.qboInvoiceLineTypes.custom
        ) {
            fpServiceContent = 'N/A'
            fpServiceTypeContent = (
                <Select
                    className="common-form-select fp-service-type-select"
                    classNamePrefix="common-form-select"
                    value={SelectUtility.selectOptionForId(
                        props.invoiceLine.fp_service_type_id,
                        props.fpServiceTypeOptions
                    )}
                    onChange={(option) => props.handleInvoiceLineSelectChange(
                        'fp_service_type_id',
                        option
                    )}
                    options={props.fpServiceTypeOptions}
                />
            )
        } else {
            fpServiceContent = (
                <Select
                    className="common-form-select fp-service-select"
                    classNamePrefix="common-form-select"
                    value={selectedFpServiceOption}
                    onChange={(option) => props.handleInvoiceLineSelectChange(
                        'fp_service_id',
                        option
                    )}
                    options={props.fpServiceOptions}
                    formatOptionLabel={(option) => (
                        <div
                            className={`fp-service-select-label fp-service-${option.value}-${option.fpServiceTypeId}`}
                        >
                            <div className="fp-service-name">{option.label}</div>
                            <div className="fp-service-type-name">{`(${option.fpServiceTypeName})`}</div>
                        </div>
                    )}
                />
            )
            fpServiceTypeContent = props.invoiceLine.fp_service_type_name
        }
    } else {
        nameContent = props.invoiceLine.name
        if (
            selectedInvoiceLineTypeOption &&
            selectedInvoiceLineTypeOption.value === Constants.qboInvoiceLineTypes.custom
        ) {
            fpServiceContent = 'N/A'
        } else {
            fpServiceContent = selectedFpServiceOption.label
        }
        fpServiceTypeContent = props.invoiceLine.fp_service_type_name
        amountContent = StringUtility.stringNumberToDisplayCurrency('' + props.invoiceLine.amount);
    }

    return (
        <div
            id={`${props.invoiceLinesFieldId}-${props.sequenceNumber}`}
            className="common-form-list-row"
        >
            <div className="common-form-list-row-content">
                <div className="common-form-list-row-cell number">
                    {props.sequenceNumber}
                </div>

                {lineTypeColumn}

                <div
                    className={props.getFormFieldClasses(
                        "common-form-list-row-cell fp-service",
                        getInvoiceLineFieldId(props.invoiceLinesFieldId, "fp_service_id", props.index)
                    )}
                >
                    {fpServiceContent}
                </div>

                <div
                    className={props.getFormFieldClasses(
                        "common-form-list-row-cell name",
                        getInvoiceLineFieldId(props.invoiceLinesFieldId, "name", props.index)
                    )}
                >
                    {nameContent}
                </div>

                <div
                    className={props.getFormFieldClasses(
                        "common-form-list-row-cell fp-service-type",
                        getInvoiceLineFieldId(props.invoiceLinesFieldId, "fp_service_type_id", props.index)
                    )}
                >
                    {fpServiceTypeContent}
                </div>

                <div
                    className={props.getFormFieldClasses(
                        "common-form-list-row-cell amount",
                        getInvoiceLineFieldId(props.invoiceLinesFieldId, "amount", props.index)
                    )}
                >
                    {amountContent}
                </div>

                {deleteColumn}
            </div>
        </div>
    )
}
